// Plugins
import GLightbox from '../../../../vendor/glightbox/glightbox.min.js';

// Local
import Animate from './partials/animate';
import AnimateInViewport from "./partials/animate-in-viewport";
import WebsiteInput from "./partials/website-input";
import RealizationList from "./partials/realization-list";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-animate-in-viewport]').forEach($item => (new AnimateInViewport($item)));
    $wrapper.querySelectorAll('[data-block-type="block-ctrl-website"]').forEach($item => (new WebsiteInput($item)));
    $wrapper.querySelectorAll('[data-block-type="block-realization-list-categories"]').forEach($el => (new RealizationList($el)));
    $wrapper.querySelectorAll('[data-form]').forEach(async($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="block-booster-slider"]').forEach(async($el) => {
        const BoosterSlider = await import('./partials/booster-slider');
        (new BoosterSlider.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="block-reference-slider"]').forEach(async($el) => {
        const ReferenceSlider = await import('./partials/reference-slider');
        (new ReferenceSlider.default($el));
    });
    $wrapper.querySelectorAll('[data-header]').forEach(async($el) => {
        const Header = await import('./partials/header');
        (new Header.default($el));
    });
    $wrapper.querySelectorAll('[data-usp-slider]').forEach(async($el) => {
        const UspSlider = await import('./partials/usp-slider');
        (new UspSlider.default($el));
    });
    $wrapper.querySelectorAll('[data-rating-stars]').forEach(async($el) => {
        const Rating = await import('./partials/rating');
        (new Rating.default($el))
    });
    $wrapper.querySelectorAll('[data-scroll-down]').forEach(async($el) => {
        const ScrollDown = await import('./partials/scroll-down');
        (new ScrollDown.default($el))
    });
    $wrapper.querySelectorAll('[data-modal').forEach(async($el) => {
        const Modal = await import('./partials/modal');
        (new Modal.default($el))
    });




    GLightbox({
        selector: '[data-glightbox]',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });
}

(function() {
    window.initDom(document);
})();